import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const IconContainer = styled.span`
  font-size: 1.2rem;
  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.grey[600]};
`;

export const Header = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.5)};
  align-items: center;
`;

export const Content = styled.div<{ $isFaded?: boolean }>`
  flex: 1;
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.5)};
  min-width: 0;
  width: 0; // makes the overflow ellipsis work correctly

  ${({ $isFaded }) =>
    $isFaded &&
    css`
      opacity: 0.5;
    `}

  ${({ theme }) =>
    theme.isMobile &&
    css`
      padding-top: ${({ theme }) => theme.spacing(0.5)};
      pointer-events: none;
    `};
`;

export const TitleContainer = styled.span<{ $isFaded: boolean }>`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  align-items: center;
  min-width: 0;

  ${({ $isFaded, theme }) =>
    $isFaded &&
    css`
      color: ${theme.palette.text.secondary};
    `};
`;

export const Title = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.body2)};

  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TimeslotButtonContainer = styled.div`
  ${({ theme }) =>
    theme.isMobile &&
    css`
      display: none;
    `};
`;
